export const authActionTypes = {
  INITIALIZE: 'initialize',
  LOGIN: 'LOGIN',
  LOGOUT: 'LOGOUT',
  LOGGED_IN: 'LOGGED_IN',
  SET_USER_AUTH: 'SET_USER_AUTH',
  SET_USER_ROLE: 'SET_USER_ROLE',
  SET_USER_AUTH_LIST: 'SET_USER_AUTH_LIST',
  GET_USER_AUTH_CS: 'GET_USER_AUTH_CS',
  EMAIL_RESET_SUCCESSFUL: 'EMAIL_RESET_SUCCESSFUL',
  LOGIN_IN_CS: 'LOGIN_IN_CS',
  FORGOT_PASSWORD_CS: 'FORGOT_PASSWORD_CS',
  RESET_PASSWORD_CS: 'RESET_PASSWORD_CS',
};

export const propertyListActionTypes = {
  INITIALIZE: 'INITIALIZE_PROPERTY_LIST',
  SET_LIST: 'SET_PROPERTY_LIST',
  LIST_CS: 'GET_LIST_PROPERTY_LIST_COMMUNICATION_STATUS',
  CREATE_PROPERTY_CS: 'CREATE_PROPERTY_CS',
  UPDATE_PROPERTY_RECORD_NOTE_CS: 'UPDATE_PROPERTY_NOTE_CS',
  EDIT_PROPERTY_RECORD_NOTE_CS: 'EDIT_PROPERTY_NOTE_CS',
  DELETE_PROPERTY_RECORD_NOTE_CS: 'DELETE_PROPERTY_NOTE_CS',
};

export const awsTokenActionType = {
  GET_UPLOAD_VIDEO_TOKEN: 'GET_UPLOAD_VIDEO_TOKEN',
  CHECK_VIDEO_UPLOADED: 'CHECK_VIDEO_UPLOADED',
  CREATE_VIDEO: 'CREATE_VIDEO',
};

export const propertyEditActionType = {
  SET_PROPERTY: 'SET_PROPERTY',
  SET_ROOMS_LISTINGS: 'SET_ROOMS_LISTINGS',
  GET_PROPERTY_CS: 'GET_PROPERTY_CS',
  GET_PROPERTY_PREVIEW_CS: 'GET_PROPERTY_PREVIEW_CS',
  SET_EDITED_FIELDS: 'SET_EDITED_FIELDS',
  SAVE_PROPERTY_CS: 'SAVE_PROPERTY_CS',
  PUBLISH_PROPERTY_CS: 'PUBLISH_PROPERTY_CS',
  RESET_PROPERTY: 'RESET_PROPERTY',
  RESET_PROPERTY_STATUS: 'RESET_PROPERTY_STATUS',
  SET_ROOMS_DATA_CHANGED: 'SET_ROOMS_DATA_CHANGED',
  SET_LISTINGS_DATA_CHANGED: 'SET_LISTINGS_DATA_CHANGED',
  SET_BULK_LISTINGS_DATA_CHANGED: 'SET_BULK_LISTINGS_DATA_CHANGED',
  UPDATE_PROPERTY_PAYLOAD: 'UPDATE_PROPERTY_PAYLOAD',
  RESET_MERGED_PROPERTY: 'RESET_MERGED_PROPERTY',
};

export const landlordInfoActionTypes = {
  SET_INFO: 'SET_INFO',
  GET_CS: 'GET_CS',
  GET_ACCOUNT_OWNER_CS: 'GET_ACCOUNT_OWNER_CS',
  SET_ACCOUNT_OWNERS: 'SET_ACCOUNT_OWNERS',
};

export const offerListActionTypes = {
  INITIALIZE: 'INITIALIZE_OFFER_LIST',
  SET_LIST: 'SET_OFFER_LIST',
  LIST_CS: 'GET_LIST_OFFER_LIST_COMMUNICATION_STATUS',
  DELETE_CS: 'DELETE_OFFER_COMMUNICATION_STATUS',
  UPDATE_CS: 'UPDATE_OFFER_COMMUNICATION_STATUS',
  CREATE_CS: 'CREATE_OFFER_COMMUNICATION_STATUS',
  SET_OPERATING_OFFER: 'SET_OPERATING_OFFER',
};

export const offerMapActionTypes = {
  INITIALIZE: 'INITIALIZE_MAP_PROPERTY',
  SET_LIST: 'SET_MAP_PROPERTY_LIST',
  LINK_CS: 'LINK_MAP_LIST_COMMUNICATION_STATUS',
  UNLINK_CS: 'UNLINK_MAP_LIST_COMMUNICATION_STATUS',
  LIST_CS: 'GET_LIST_MAP_PROPERTY_COMMUNICATION_STATUS',
};

export const roomListingsActionTypes = {
  INITIALIZE: 'INITIALIZE_ROOM_LISTINGS',
  SET_LIST: 'SET_ROOM_LISTINGS_LIST',
  SET_CHECKED_ROW_KEYS: 'SET_CHECKED_ROW_KEYS',
  SET_UPDATED_ROW_KEY: 'SET_UPDATED_ROW_KEY',
  LIST_CS: 'GET_LIST_ROOM_LISTINGS_COMMUNICATION_STATUS',
  CREATE_CS: 'CREATE_ROOM_LISTING_COMMUNICATION_STATUS',
  UPDATE_CS: 'UPDATE_ROOM_LISTING_COMMUNICATION_STATUS',
  DELETE_CS: 'REMOVE_ROOM_LISTING_COMMUNICATION_STATUS',
};

export const unitTypesActionTypes = {
  INITIALIZE: 'INITIALIZE_UNIT_TYPES',
  SET_LIST: 'SET_UNIT_TYPES_LIST',
  LIST_CS: 'GET_LIST_UNIT_TYPES_COMMUNICATION_STATUS',
  CREATE_CS: 'CREATE_ROOM_UNIT_TYPE_COMMUNICATION_STATUS',
  UPDATE_CS: 'UPDATE_ROOM_UNIT_TYPE_COMMUNICATION_STATUS',
  DELETE_CS: 'DELETE_ROOM_UNIT_TYPE_COMMUNICATION_STATUS',
};

export const classificationsActionTypes = {
  INITIALIZE: 'INITIALIZE_CLASSIFICATIONS',
  SET_LIST: 'SET_CLASSIFICATIONS_LIST',
  LIST_CS: 'GET_LIST_ROOM_CLASSIFICATIONS_COMMUNICATION_STATUS',
  CREATE_CS: 'CREATE_ROOM_CLASSIFICATIONS_COMMUNICATION_STATUS',
  UPDATE_CS: 'UPDATE_ROOM_CLASSIFICATIONS_COMMUNICATION_STATUS',
  DELETE_CS: 'DELETE_ROOM_CLASSIFICATIONS_COMMUNICATION_STATUS',
  DISTINCTION_TO_UNIT_TYPE_CS:
    'ADD_OR_REMOVE_ROOM_CLASSIFICATION_TO_UNIT_TYPES_COMMUNICATION_STATUS',
  UPDATE_LIST_ITEM: 'UPDATE_ROOM_CLASSIFICATION_ITEM',
};

export const distinctionsActionTypes = {
  INITIALIZE: 'INITIALIZE_DISTINCTIONS',
  SET_LIST: 'SET_DISTINCTIONS_LIST',
  LIST_CS: 'GET_LIST_DISTINCTIONS_COMMUNICATION_STATUS',
  CREATE_CS: 'CREATE_ROOM_DISTINCTIONS_COMMUNICATION_STATUS',
  UPDATE_CS: 'UPDATE_ROOM_DISTINCTIONS_COMMUNICATION_STATUS',
  DELETE_CS: 'DELETE_ROOM_DISTINCTIONS_COMMUNICATION_STATUS',
  DISTINCTION_TO_UNIT_TYPE_CS: 'ADD_OR_REMOVE_ROOM_DISTINCTIONS_TO_UNIT_TYPES_COMMUNICATION_STATUS',
  UPDATE_LIST_ITEM: 'UPDATE_ROOM_DISTINCTION_ITEM',
};

export const udeskActionTypes = {
  GET_STUDENT_CS: 'GET_STUDENT_CS',
  SET_STUDENT: 'SET_STUDENT',
  SET_PARTNER: 'SET_PARTNER',
};

export const countryActionTypes = {
  INITIALIZE: 'INITIALIZE_COUNTRY_LIST',
  SET_LIST: 'SET_COUNTRY_LIST',
  LIST_CS: 'GET_LIST_COUNTRY_LIST_COMMUNICATION_STATUS',
};

export const cityActionTypes = {
  CHECK_CITY_EXIST: 'CHECK_CITY_EXIST',
  SET_CITY_DETAIL: 'SET_CITY_DETAIL',
  SET_CITY_BASE: 'SET_CITY_BASE',
  GET_CITY_DETAIL: 'GET_CITY_DETAIL',
  GET_CITY_DETAIL_CS: 'GET_CITY_DETAIL_COMMUNICATION_STATUS',
  INITIALIZE: 'INITIALIZE_CITY_LIST',
  SET_LIST: 'SET_CITY_LIST',
  LIST_CS: 'GET_LIST_CITY_LIST_COMMUNICATION_STATUS',
  CREATE_CS: 'CREATE_CITY_COMMUNICATION_STATUS',
  UPDATE_CS: 'UPDATE_CITY_COMMUNICATION_STATUS',
};

export const universityActionTypes = {
  INITIALIZE: 'INITIALIZE_UNIVERSITY_LIST',
  SET_LIST: 'SET_UNIVERSITY_LIST',
  LIST_CS: 'GET_LIST_UNIVERSITY_LIST_COMMUNICATION_STATUS',
  SET_UNIVERSITY_DETAIL: 'SET_UNIVERSITY_DETAIL',
  SET_UNIVERSITY_BASE: 'SET_UNIVERSITY_BASE',
  GET_UNIVERSITY_DETAIL: 'GET_UNIVERSITY_DETAIL',
  GET_UNIVERSITY_DETAIL_CS: 'GET_UNIVERSITY_DETAIL_COMMUNICATION_STATUS',
  CREATE_CS: 'CREATE_UNIVERSITY_COMMUNICATION_STATUS',
  UPDATE_CS: 'UPDATE_UNIVERSITY_COMMUNICATION_STATUS',
  CHECK_UNIVERSITY_EXIST: 'CHECK_UNIVERSITY_EXIST',
};

export const imageActionTypes = {
  UPDATE_CS: 'UPDATE_IMAGE_COMMUNICATION_STATUS',
  DELETED_CS: 'DELETED_IMAGE_COMMUNICATION_STATUS',
  CREATE_CS: 'CREATE_IMAGE_COMMUNICATION_STATUS',
};

export const galleryActionTypes = {
  SHRINK_CS: 'SHRINK_GALLERY_MODAL',
};

export const commissionActionTypes = {
  UPDATE_CS: 'UPDATE_COMMISSION_COMMUNICATION_STATUS',
  CREATE_CS: 'CREATE_COMMISSION_COMMUNICATION_STATUS',
  DELETE_CS: 'DELETE_COMMISSION_COMMUNICATION_STATUS',
  GET_PROPERTY_COMMISSION_TIERS_CS: 'GET_PROPERTY_COMMISSION_TIERS_CS',
  SET_PROPERTY_COMMISSION_TIERS_CS: 'SET_PROPERTY_COMMISSION_TIERS_CS',
  GET_LANDLORD_PROPERTIES_CS: 'GET_LANDLORD_PROPERTIES_CS',
  SET_LANDLORD_PROPERTIES: 'SET_LANDLORD_PROPERTIES',
  BULK_CREATE_CS: 'BULK_CREATE_CS',
};

export const depositActionTypes = {
  UPDATE_CS: 'UPDATE_DEPOSIT_COMMUNICATION_STATUS',
  CREATE_CS: 'CREATE_DEPOSIT_COMMUNICATION_STATUS',
  DELETE_CS: 'DELETED_DEPOSIT_COMMUNICATION_STATUS',
  UPDATE_PROPERTY_CS: 'UPDATE_PROPERTY_COMMUNICATION_STATUS',
  GET_PROPERTY_DEPOSIT_CS: 'GET_PROPERTY_DEPOSIT_CS',
  SET_PROPERTY_DEPOSIT_CS: 'SET_PROPERTY_DEPOSIT_CS',
};

export const contractActionTypes = {
  UPDATE_CONTRACT_CS: 'UPDATE_CONTRACT_CS',
  CREATE_CONTRACT_CS: 'CREATE_CONTRACT_CS',
  DELETE_CONTRACT_CS: 'DELETE_CONTRACT_CS',
  SET_CONTRACT_LIST: 'SET_CONTRACT_LIST',
  GET_CONTRACT_LIST_CS: 'GET_CONTRACT_LIST_CS',
  BULK_DUALLY_SIGNED_PROPERTY: 'BULK_DUALLY_SIGNED_PROPERTY',
  LANDLORD_LIST_CS: 'LANDLORD_LIST_CS',
  SET_LANDLORD_LIST: 'SET_LANDLORD_LIST',
  LANDLORD_SELECTED_CS: 'LANDLORD_SELECTED_CS',
};

export const pendingApprovalActionTypes = {
  SET_LIST: 'SET_DRAFTS',
  LIST_CS: 'GET_DRAFTS_COMMUNICATION_STATUS',
  GET_DRAFT_DETAIL_CS: 'SET_DRAFT_DETAIL_COMMUNICATION_STATUS',
  SET_DRAFT_DETAIL: 'SET_DRAFT_DETAIL',
  REJECT_CS: 'REJECT_DRAFT_COMMUNICATION_STATUS',
  APPROVAL_CS: 'APPROVAL_DRAFT_COMMUNICATION_STATUS',
  CANCEL_CS: 'CANCEL_DRAFT_COMMUNICATION_STATUS',
  PENDING_APPROVAL_PROPERTY_DRAFT_CS: 'PENDING_APPROVAL_PROPERTY_DRAFT_CS',
  SAVE_PROPERTY_DRAFT_CS: 'SAVE_PROPERTY_DRAFT_CS',
  SET_MERGED_DRAFT_PROPERTY: 'SET_MERGED_DRAFT_PROPERTY',
  GET_PROPERTY_COMMENTS_CS: 'GET_PROPERTY_COMMENTS_CS',
  SET_PROPERTY_COMMENTS: 'SET_PROPERTY_COMMENTS',
  PROCESS_PROPERTY_DRAFT_CS: 'PROCESS_PROPERTY_DRAFT_CS',
  EXPIRE_PROPERTY_DRAFT_CS: 'EXPIRE_PROPERTY_DRAFT_CS',
};

export const recordActionTypes = {
  GET_PROPERTY_NOTE_CS: 'GET_PROPERTY_NOTE_CS',
  SET_PROPERTY_NOTE_CS: 'SET_PROPERTY_NOTE_CS',
};

export const accountActionTypes = {
  LANDLORD_LIST_CS: 'LANDLORD_LIST_CS',
  GET_CMS_USER_CS: 'GET_CMS_USER_CS',
  SET_CMS_USER: 'SET_CMS_USER',
  UPDATE_CS: 'UPDATE_ACCOUNT_COMMUNICATION_STATUS',
  CREATE_CS: 'CREATE_ACCOUNT_COMMUNICATION_STATUS',
  INITIALIZE: 'INITIALIZE_ACCOUNT_LIST',
  SET_LIST: 'SET_ACCOUNT_LIST',
  LIST_CS: 'GET_ACCOUNT_LIST_COMMUNICATION_STATUS',
  GET_ACCOUNT_DETAIL_CS: 'GET_ACCOUNT_DETAIL_CS',
  LANDLORD_UPDATE_CS: 'LANDLORD_UPDATE_COMMUNICATION_STATUS',
  LANDLORD_CREATE_CS: 'LANDLORD_CREATE_COMMUNICATION_STATUS',
  SET_ACCOUNT_LANDLORD_LIST: 'SET_ACCOUNT_LANDLORD_LIST',
  ACCOUNT_LANDLORD_LIST_CS: 'GET_ACCOUNT_LANDLORD_LIST_COMMUNICATION_STATUS',
  ACCOUNT_LANDLORD_PROPERTY_CS: 'GET_ACCOUNT_LANDLORD_PROPERTY_COMMUNICATION_STATUS',
};

export const reviewsTypes = {
  LIST_CS: 'GET_REVIEW_LIST_COMMUNICATION_STATUS',
  SET_LIST: 'SET_REVIEW_LIST',
  DELETE_CS: 'DELETE_REVIEW_COMMUNICATION_STATUS',
  REJECT_CS: 'REJECT_REVIEW_COMMUNICATION_STATUS',
  APPROVAL_CS: 'APPROVAL_REVIEW_COMMUNICATION_STATUS',
};

export const changeLogActionTypes = {
  GET_PROPERTY_CHANGE_LOGS_CS: 'GET_PROPERTY_CHANGE_LOGS_CS',
  SET_PROPERTY_CHANGE_LOGS: 'SET_PROPERTY_CHANGE_LOGS',
  GET_CHANGE_LOGS_USER_LIST: 'GET_CHANGE_LOGS_USER_LIST',
};

export const landlordActionTypes = {
  GET_LANDLORDS_CS: 'GET_LANDLORDS_CS',
  SET_LANDLORDS: 'SET_LANDLORDS',
  LANDLORD_LIST_CS: 'LANDLORD_LIST_CS',
  SET_CURRENT_LANDLORD: 'SET_CURRENT_LANDLORD',
  GET_LANDLORD_CS: 'GET_LANDLORD_CS',
  SET_PREPARED_CONTRACT: 'SET_PREPARED_CONTRACT',
  CREATE_LANDLORD_CS: 'CREATE_LANDLORD_CS',
  UPDATE_LANDLORD_CS: 'UPDATE_LANDLORD_CS',
  GET_PROPERTIES_BY_LANDLORD_SLUG_CS: 'GET_PROPERTIES_BY_LANDLORD_SLUG_CS',
  SET_PROPERTIES_OF_LANDLORD: 'SET_PROPERTIES_OF_LANDLORD',
  SEARCH_PROPERTY_NAME_LIST_CS: 'SEARCH_PROPERTY_NAME_LIST_CS',
  GET_DISPLAY_COUNTRY_LIST_CS: 'GET_DISPLAY_COUNTRY_LIST_CS',
  BIND_AUTO_CONFIRM_SETTINGS: 'BIND_AUTO_CONFIRM_SETTINGS',
  SET_ACCOUNT_OWNERS: 'SET_ACCOUNT_OWNERS',
  GET_ACCOUNT_OWNER_CS: 'GET_ACCOUNT_OWNER_CS',
  GET_SYSTEM_PROVIDER_LIST_CS: 'GET_SYSTEM_PROVIDER_LIST_CS',
  SET_RECONCILIATION_PREFERENCE_LIST: 'SET_RECONCILIATION_PREFERENCE_LIST',
};

export const listingManagementActionType = {
  SET_PROPERTY: 'SET_PROPERTY',
  GET_PROPERTY_CS: 'GET_PROPERTY_CS',
  PUBLISH_PROPERTY_CS: 'PUBLISH_PROPERTY_CS',
  GET_PROPERTY_PREVIEW_CS: 'GET_PROPERTY_PREVIEW_CS',
  DELETE_ROOM_CS: 'DELETE_ROOM_CS',
  CREATE_ROOM_CS: 'CREATE_ROOM_CS',
  UPDATE_ROOM_CS: 'UPDATE_ROOM_CS',
  SET_NEED_CONFIRM_ROOM_LISTING: 'SET_NEED_CONFIRM_ROOM_LISTING',
  CREATE_LISTING_CS: 'CREATE_LISTING_CS',
  DELETE_LISTING_CS: 'DELETE_LISTING_CS',
  UPDATE_LISTING_CS: 'UPDATE_LISTING_CS',
  BULK_UPDATE_LISTING_CS: 'BULK_UPDATE_LISTING_CS',
  BULK_DELETE_LISTING_CS: 'BULK_DELETE_LISTING_CS',
  UPDATE_GALLERY_CS: 'UPDATE_GALLERY_CS',
  SET_COVER_PHOTO_DELETED: 'SET_COVER_PHOTO_DELETED',
  GET_UNIT_TYPE_FACILITIES: 'GET_UNIT_TYPE_FACILITIES',
};

export const billingActionTypes = {
  GET_LIST_ORDER_TRANSFER_CS: 'GET_LIST_ORDER_TRANSFER_CS',
  SET_LIST_ORDER_TRANSFER: 'SET_LIST_ORDER_TRANSFER',
  SET_ORDER_TRANSFER: 'SET_ORDER_TRANSFER',
  GET_ORDER_TRANSFER: 'GET_ORDER_TRANSFER',
  GET_PENDING_TRANSFER_COUNT: 'GET_PENDING_TRANSFER_COUNT',
  GET_PENDING_RECEIVABLES_COUNT: 'GET_PENDING_RECEIVABLES_COUNT',
  UPDATE_ORDER_TRANSFERRED_CS: 'UPDATE_ORDER_TRANSFERRED_CS',
  LANDLORD_LIST_CS: 'LANDLORD_LIST_CS',
  PROPERTY_LIST_CS: 'PROPERTY_LIST_CS',
  GET_LIST_ORDER_RECEIVE_CS: 'GET_LIST_ORDER_RECEIVE_CS',
  SET_LIST_ORDER_RECEIVE: 'SET_LIST_ORDER_RECEIVE',
  SET_ORDER_RECEIVE: 'SET_ORDER_RECEIVE',
  GET_ORDER_RECEIVE: 'GET_ORDER_RECEIVE',
  UPDATE_ORDER_RECEIVABLE_CS: 'UPDATE_ORDER_RECEIVABLE_CS',
  SET_LIST_ORDER_REFUND: 'SET_LIST_ORDER_REFUND',
  GET_LIST_ORDER_REFUND_CS: 'GET_LIST_ORDER_REFUND_CS',
  GET_ORDER_REFUND: 'GET_ORDER_REFUND',
  SET_ORDER_REFUND: 'SET_ORDER_REFUND',
  GET_PENDING_REFUNDS_COUNT: 'GET_PENDING_REFUNDS_COUNT',
  FINANCIAL_REFUNDED_CS: 'FINANCIAL_REFUNDED_CS',
  REFUNDED_CONFIRM_CS: 'REFUNDED_CONFIRM_CS',
};

export const reconciliationActionTypes = {
  GET_LIST_RECONCILIATION_LANDLORDS_CS: 'GET_LIST_RECONCILIATION_LANDLORDS_CS',
  SET_LIST_RECONCILIATION_LANDLORDS: 'SET_LIST_RECONCILIATION_LANDLORDS',
  GET_LIST_OPPORTUNITY_RECONCILIATION: 'GET_LIST_OPPORTUNITY_RECONCILIATION',
  GET_LIST_OPPORTUNITY_RECONCILIATION_CS: 'GET_LIST_OPPORTUNITY_RECONCILIATION_CS',
  SET_LIST_RECONCILIATION_BULK_UPDATE_RECORDS: 'SET_LIST_RECONCILIATION_BULK_UPDATE_RECORDS',
  GET_LIST_RECONCILIATION_BULK_UPDATE_RECORDS_CS: 'GET_LIST_RECONCILIATION_BULK_UPDATE_RECORDS_CS',
  LANDLORD_LIST_CS: 'LANDLORD_LIST_CS',
  PROPERTY_LIST_CS: 'PROPERTY_LIST_CS',
  COUNTRY_LIST_CS: 'COUNTRY_LIST_CS',
  CITY_LIST_CS: 'CITY_LIST_CS',
};

export const propertyTermsActionTypes = {
  GET_PROPERTY_TERMS: 'GET_PROPERTY_TERMS_CS',
  SET_PROPERTY_TERMS: 'SET_PROPERTY_TERMS',
  CREATE_PROPERTY_TERMS: 'CREATE_PROPERTY_TERMS_CS',
  UPDATE_PROPERTY_TERMS: 'UPDATE_PROPERTY_TERMS_CS',
  DELETE_PROPERTY_TERMS: 'DELETE_PROPERTY_TERMS_CS',
};

export const apiTokenActionTypes = {
  CREATE_API_TOKEN: 'CREATE_API_TOKEN',
  GET_API_TOKENS: 'GET_API_TOKENS',
  UPDATE_API_TOKEN: 'UPDATE_API_TOKEN',
};

export const paymentActionTypes = {
  GET_LIST: 'GET_LIST',
  SET_LIST: 'SET_LIST',
  GET_LIST_CS: 'GET_LIST_COMMUNICATION_STATUS',
  SET_SETUP: 'SET_SETUP',
  SET_SELECTED_PROPERTY_IDS: 'SET_SELECTED_PROPERTY_IDS',
  CREATE_CONNECTED_ACCOUNT_CS: 'CREATE_CONNECTED_ACCOUNT_COMMUNICATION_STATUS',
  SET_CONNECTED_ACCOUNT_ID: 'SET_CONNECTED_ACCOUNT_ID',
  UPDATE_PAYMENT_DEPOSIT_RULES: 'UPDATE_PAYMENT_DEPOSIT_RULES',
  UPDATE_PAYMENT_FIRST_INSTALMENT: 'UPDATE_PAYMENT_FIRST_INSTALMENT',
  SKIP_PAYMENT_FIRST_INSTALMENT: 'SKIP_PAYMENT_FIRST_INSTALMENT',
  UPDATE_TERMS_AND_CONDITIONS: 'UPDATE_TERMS_AND_CONDITIONS',
  UPDATE_PAYMENT_PROCESS: 'UPDATE_PAYMENT_PROCESS',
  UPDATE_PAYMENT_ENABLED: 'UPDATE_PAYMENT_ENABLED',
  RESET_PAYMENT: 'RESET_PAYMENT',
  GET_STRIPE_CLIENT_ID_CS: 'GET_STRIPE_CLIENT_ID_COMMUNICATION_STATUS',
  SET_STRIPE_CLIENT_ID: 'SET_STRIPE_CLIENT_ID',
  GET_LONG_TAIL_PAYMENT_PLAN_CS: 'GET_LONG_TAIL_PAYMENT_PLANCOMMUNICATION_STATUS',
  CREATE_LONG_TAIL_PAYMENT_PLAN_CS: 'CREATE_LONG_TAIL_PAYMENT_PLAN_COMMUNICATION_STATUS',
  DELETE_LONG_TAIL_PAYMENT_PLAN_CS: 'DELETE_LONG_TAIL_PAYMENT_PLAN_COMMUNICATION_STATUS',
  UPDATE_LONG_TAIL_PAYMENT_PLAN_CS: 'UPDATE_LONG_TAIL_PAYMENT_PLAN_COMMUNICATION_STATUS',
  SET_LONG_TAIL_PAYMENT_PLAN: 'SET_LONG_TAIL_PAYMENT_PLAN',
  RESET_LONG_TAIL_PAYMENT_PLAN: 'RESET_LONG_TAIL_PAYMENT_PLAN',
  GET_LONG_TAIL_INSTALMENT_PLAN_CS: 'GET_LONG_TAIL_INSTALMENT_PLANCOMMUNICATION_STATUS',
  CREATE_LONG_TAIL_INSTALMENT_PLAN_CS: 'CREATE_LONG_TAIL_INSTALMENT_PLAN_COMMUNICATION_STATUS',
  DELETE_LONG_TAIL_INSTALMENT_PLAN_CS: 'DELETE_LONG_TAIL_INSTALMENT_PLAN_COMMUNICATION_STATUS',
  UPDATE_LONG_TAIL_INSTALMENT_PLAN_CS: 'UPDATE_LONG_TAIL_INSTALMENT_PLAN_COMMUNICATION_STATUS',
  CREATE_ORDER_DEPOSIT_CS: 'CREATE_ORDER_DEPOSIT_COMMUNICATION_STATUS',
  UPDATE_ORDER_DEPOSIT_CS: 'UPDATE_ORDER_DEPOSIT_COMMUNICATION_STATUS',
  DELETE_ORDER_DEPOSIT_CS: 'DELETE_ORDER_DEPOSIT_COMMUNICATION_STATUS',
  CREATE_ORDER_FEE_CS: 'CREATE_ORDER_FEE_COMMUNICATION_STATUS',
  UPDATE_ORDER_FEE_CS: 'UPDATE_ORDER_FEE_COMMUNICATION_STATUS',
  DELETE_ORDER_FEE_CS: 'DELETE_ORDER_FEE_COMMUNICATION_STATUS',
  GET_LONGTAIL_PAYMENT_PLANS_CS: 'GET_LONGTAIL_PAYMENT_PLANS_COMMUNICATION_STATUS',
  SET_LONGTAIL_PAYMENT_PLANS: 'SET_LONGTAIL_PAYMENT_PLANS',
};

export const tagsListActionTypes = {
  SET_LIST: 'SET_TAGS_LIST',
  LIST_CS: 'GET_LIST_TAGS_LIST_COMMUNICATION_STATUS',
};
